import styled from "styled-components";
import { Box, colors } from "@mui/material";
import { ReactComponent as facebookMessenger } from "../../../assets/icons/facebookMessenger.svg";

export const ShareItem = styled(Box)`
	border-radius: 50%;
	background: ${colors.grey[200]};
`;

export const StyledFacebookMessenger = styled(facebookMessenger)`
	fill: ${colors.grey[600]};
	width: 33px;
	height: 33px;
`;

export const AutocompleteWrapper = styled(Box)`
	.MuiAutocomplete-input {
		width: 100% !important;
	}

	.chipsWrapper {
		max-height: 200px;
		overflow: auto;
	}
`;

export const QRCodeWrapper = styled(Box)`
	margin-bottom: 20px;
`;
